import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { AppointmentRequest } from '../models/appointment-request.model';
import { AppointmentRequestKind } from '../models/appointment-request-kind.model';
import { AppointmentRequestStatus } from '../models/appointment-request-status.model';

export interface IAppointmentRequestsRepository {
  // Status(+kind) filtered list, e.g. `{ status: 'confirmado', kind: 'cancelacion' }` -- backs
  // AppointmentChangeRequestsStore's recent-cancellations poll, the only caller left now that
  // appointment_requests is a record rather than a queue.
  list(status: AppointmentRequestStatus, kind?: AppointmentRequestKind): Observable<readonly AppointmentRequest[]>;
}

export const APPOINTMENT_REQUESTS_REPOSITORY = new InjectionToken<IAppointmentRequestsRepository>(
  'IAppointmentRequestsRepository',
);
